<div class="login-page" data-bs-theme="dark">
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <p class="text-body-secondary small mb-0">All of American Agriculture Connected</p>
    </div>
    <h2 class="h5 fw-semibold mb-4">Sign in to the Admin Portal</h2>

    <!-- Error Alert -->
    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle me-2"></i>
      {{ errorMessage }}
      <div *ngIf="showResendVerification" class="mt-2">
        <button
          type="button"
          class="btn btn-sm btn-outline-danger"
          [disabled]="resendingVerification"
          (click)="resendVerificationEmail()"
        >
          <span *ngIf="!resendingVerification">Resend Verification Email</span>
          <span *ngIf="resendingVerification">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Sending...
          </span>
        </button>
      </div>
    </div>

    <!-- Verification Success -->
    <div *ngIf="verificationMessage" class="alert alert-success" role="alert">
      <i class="bi bi-check-circle me-2"></i>
      {{ verificationMessage }}
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <!-- Email Input -->
      <div class="mb-3">
        <label for="email" class="form-label">Email Address <span class="text-danger">*</span></label>
        <input
          type="email"
          class="form-control"
          [class.is-invalid]="hasError('email')"
          id="email"
          formControlName="email"
          placeholder="admin@example.com"
          autocomplete="email"
        />
        <div class="invalid-feedback" *ngIf="hasError('email')">
          {{ getErrorMessage('email') }}
        </div>
      </div>

      <!-- Password Input -->
      <div class="mb-3">
        <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            [class.is-invalid]="hasError('password')"
            id="password"
            formControlName="password"
            placeholder="Enter your password"
            autocomplete="current-password"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="togglePasswordVisibility()"
          >
            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        <div class="invalid-feedback d-block" *ngIf="hasError('password')">
          {{ getErrorMessage('password') }}
        </div>
      </div>

      <!-- Forgot Password Link -->
      <div class="text-end">
        <a routerLink="/forgot-password" class="text-decoration-none text-body-secondary">
          Forgot password?
        </a>
      </div>

      <!-- Submit Button -->
      <button
        type="submit"
        class="btn btn-primary btn-lg w-100 mt-4"
        [disabled]="loginForm.invalid || loading"
      >
        <span *ngIf="!loading">Sign In</span>
        <span *ngIf="loading">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Signing in...
        </span>
      </button>
    </form>

    <!-- Internal Use Only Notice -->
    <p class="text-center text-muted small mt-4 mb-0">
      <i class="bi bi-shield-lock me-1"></i>
      This portal is for authorized ADN staff only
    </p>

    <!-- Legal footer (same links as the web portal's LEGAL_URLS). `noreferrer`
         keeps the admin URL out of the Referer sent to the policy host. -->
    <p class="text-center text-muted small mt-2 mb-0">
      By continuing you agree to the
      <a href="https://www.americandronenetwork.com/privacy-policy/" target="_blank" rel="noopener noreferrer" class="text-decoration-none">Privacy Policy</a>
      and
      <a href="https://www.americandronenetwork.com/terms-conditions/" target="_blank" rel="noopener noreferrer" class="text-decoration-none">Terms of Use</a>.
    </p>
  </div>
</div>
